import { Route, Routes } from "react-router-dom";
import { ElasticDataGrid } from "components/DataGrid/RevivnElasticDataGrid";
import { columns } from "components/Inventories/DataGrid/datagridColumns";
import React from "react";
import { BulkActions } from "components/Inventories/DataGrid/BulkActions";
import { GridBulkPrintActionItem } from "components/Inventories/DataGrid/GridBulkPrintActionItem";
import { PageBreadcrumbs, PageTitle } from "pages/Layouts/components/PageTitleContainer";
import { FullPagePaperLayout } from "pages/Layouts/FullPagePaperLayout";
import { HomeOutlined } from "@mui/icons-material";

const IndexElement = () => {
  return (
    <>
      <PageBreadcrumbs links={[{ label: "Warehouse", icon: <HomeOutlined /> }]} />
      <PageTitle>Inventory</PageTitle>
      <FullPagePaperLayout>
        <BulkActions />
        <ElasticDataGrid
          autoHeight={false}
          checkboxSelection={true}
          columns={columns}
          density="compact"
          defaultToMostRecentParams
          syncStateWithSearchParams
          persistSettingsKey={"inventories"}
          url={"/inventories/elastic_index"}
          getBulkActions={() => [<GridBulkPrintActionItem />]}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
            },
          }}
          initialState={{
            columns: {
              columnVisibilityModel: {
                lineId: false,
                pickupId: false,
                printed: false,
                inventoryImagesCount: false,
                iqInventoryId: false,
                iqPoIdLine: false,
                assetTag: false,
                locationAncestorIds: false,
                inventoryType: false,
              },
            },
          }}
        />
      </FullPagePaperLayout>
    </>
  );
};

export default function InventoriesPage() {
  return (
    <Routes>
      <Route index element={<IndexElement />} />
    </Routes>
  );
}
